import * as S from './buttons.styles'
import { CartBagIcon } from '../../../icons'
import { useCartDrawer } from '../../../features/cart/components/CartDrawerProvider'
import { BAG_OPEN_SOURCE } from '../../../features/cart/cart.consts'
import CartCountBadge from './CartCountBadge/CartCountBadge'
import { useExperimentManager } from 'services/ExperimentManager/ExperimentManager'

export default function CartBagButton({ color }: { color?: string }) {
  const { openCart } = useCartDrawer()
  const experimentManager = useExperimentManager()

  return (
    <S.Clickable
      onClick={() => openCart(BAG_OPEN_SOURCE.TOP_BAR)}
      $color={color}
      data-testid="cart-bag-button"
    >
      <S.IconWrapper>
        <CartBagIcon color={color} />
        {experimentManager.isEnabled('header-bag-count-badge') && (
          <CartCountBadge />
        )}
      </S.IconWrapper>
    </S.Clickable>
  )
}
